import React, { PureComponent } from 'react';
import MarineMonitoringState from 'contexts/MarineMonitoringState';

export default WrappedComponent => {
  return class extends PureComponent {
    static contextType = MarineMonitoringState;
    render() {
      const consumedFromContext = this.context;
      return <WrappedComponent {...this.props} {...consumedFromContext} />;
    }
  };
};
